import { Component, OnInit, AfterViewInit, OnDestroy, HostListener, ElementRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import {
  MemberQuery,
  ProviderName,
  KeyValuePair,
  NotificationCenterService,
  TMAuthService,
  CardService,
  AuthService,
  MemberDetails,
  ChildQuery,
} from '@fgb/core';
import { Observable, Subject } from 'rxjs';
import { tap, takeUntil } from 'rxjs/operators';
import { Populations } from 'src/app/shared/utilities/populations';
import { ProductCode } from 'src/app/shared/utilities/product-code';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { Tags } from 'src/app/shared/utilities/tags';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'fgb-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss'],
  animations: [
    trigger('rightNavAnimation', [
      state('open', style({ transform: 'translateX(0)', opacity: 1 })),
      state('close', style({ transform: 'translateX(100%)', opacity: 0.2 })),
      transition('open <=> close', [animate('300ms cubic-bezier(0.25, 0.8, 0.25, 1)')]),
    ]),
    trigger('rightMenuOverlayAnimation', [
      transition(':enter', [
        style({ opacity: 0, display: 'none' }),
        animate('300ms cubic-bezier(0.25, 0.8, 0.25, 1)', style({ opacity: 1, display: 'block' })),
      ]),
      transition(':leave', [
        style({ opacity: 1, display: 'block' }),
        animate('300ms cubic-bezier(0.25, 0.8, 0.25, 1)', style({ opacity: 0, display: 'none' })),
      ]),
    ]),
  ],
})
export class NavBarComponent implements OnInit, AfterViewInit, OnDestroy {
  populations = Populations;
  productcode = ProductCode;
  tags = Tags;
  children$: Observable<{ data: any[]; free: any[]; empty: any[]; limit: number }>;

  isNavOpen: boolean = false;
  public discountURL: string = '';

  memberDetails$: Observable<MemberDetails | undefined>;
  private _destroyed$ = new Subject();

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    const target = event.target as HTMLElement;
    if (target.closest('.right-nav-menu-overlay')) {
      this.isNavOpen = false;
      return;
    }

    if (this.isNavOpen && !this._el.nativeElement.contains(target)) {
      this.isNavOpen = false;
    }
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize(event: Event) {
    this.isNavOpen = false;
  }

  constructor(
    private translate: TranslateService,
    public router: Router,
    public cardService: CardService,
    public memberQuery: MemberQuery,
    private authService: AuthService,
    private notificationService: NotificationCenterService,
    public tmOauthService: TMAuthService,
    private _el: ElementRef,
    private childQuery: ChildQuery
  ) {}

  useLanguage(language: string) {
    this.translate.use(language);
  }

  ngOnInit() {
    this.discountLink();
    this.memberDetails$ = this.memberQuery.selectMemberDetails();
    this.children$ = this.childQuery.getChildrenInfo();

    this.router.events.pipe(takeUntil(this._destroyed$)).subscribe(() => {
      this.isNavOpen = false;
    });
  }

  ngAfterViewInit() {}

  ngOnDestroy() {
    this._destroyed$.next;
    this._destroyed$.complete();
  }

  discountLink() {
    this.translate
      .stream('discount.url')
      .pipe(takeUntil(this._destroyed$))
      .subscribe((data: string) => {
        this.discountURL = data;
      });
  }

  logout() {
    this.authService
      .logout()
      .pipe(tap(() => this.router.navigate(['/login'])))
      .toPromise();
  }

  selectCard() {
    this.router.navigate(['/login']);
  }

  LoginThirdParty() {
    let options = [{ key: 'Url', value: 'https://sdp.sportsbingo.ballparkapps.com/?bingoUser={1}' }] as KeyValuePair[];
    this.authService.loginThirdParty(ProviderName.SidelineSports, 1, '', true, options);
  }

  toggleNotificationCenter(open: boolean) {
    this.notificationService.updateIsOpen(open);
  }

  loginWithCard(memberId: string) {
    this.authService.switchUser(memberId).toPromise();
  }

  closeDropDown(dropdown: NgbDropdown) {
    dropdown.close();
  }

  ticketingSSO() {
    this.tmOauthService.ssoToModernAccountRedirect();
  }

  switchToGuardian() {
    this.authService
      .switchToGuardian()
      .toPromise()
      .then(() => {
        this.router.navigate(['/']).then(() => {
          location.reload();
        });
      });
  }
}
